@if (reportData(); as data) {
  <div class="page-wrapper">

    <!-- Toolbar (hidden when printing) -->
    <div class="print-toolbar no-print">
      <div class="toolbar-left">
        <mat-icon class="toolbar-icon">description</mat-icon>
        <div>
          <div class="toolbar-title">Highp Media Library Report</div>
          <div class="toolbar-meta">Generated on {{ data.generatedAt }}</div>
        </div>
      </div>
      <cm-ui-standard-button rounded icon="print" (onClick)="print()">Print</cm-ui-standard-button>
    </div>

    <!-- Report Content -->
    <div class="report-container">

      <!-- Print-only header -->
      <div class="print-only-header">
        <mat-icon>description</mat-icon>
        <div>
          <div class="report-title">Highp Media Library Report</div>
          <div class="report-meta">Generated on {{ data.generatedAt }}</div>
        </div>
      </div>

      @for (asset of data.assets; track asset.uuid) {
        <div class="asset-card">

          <div class="asset-card-header">
            <div class="asset-preview-wrap">
              <img class="asset-preview"
                   [src]="thumbnailUrl(asset.filename!)"
                   [alt]="asset.name"
                   (error)="$any($event.target).parentElement.innerHTML='<div class=\'asset-preview-placeholder\'>No preview</div>'" />
            </div>
            <div class="asset-header-info">
              <div class="asset-name">{{ asset.name }}</div>
              <div class="asset-filename"><div>Asset filename: </div>{{ asset.filename }}</div>
              <div class="asset-date"><div>Created at: </div>{{ toDate(asset.lastUpdated) | date:'medium' }}</div>
            </div>
          </div>

          <div class="asset-card-body">

            <!-- Creator -->
            <div class="section">
              <div class="section-label">Recorded / Uploaded by</div>
              @if (asset.createdBy) {
                <div class="creator-card">
                  <div class="creator-avatar">{{ creatorInitials(asset.createdBy) }}</div>
                  <div>
                    <div class="creator-name">{{ asset.createdBy.firstName }} {{ asset.createdBy.lastName }}</div>
                    @if (asset.createdBy.businessTitle) {
                      <div class="creator-detail">{{ asset.createdBy.businessTitle }}</div>
                    }
                    @if (asset.createdBy.email) {
                      <div class="creator-detail">{{ asset.createdBy.email }}</div>
                    }
                    @if (asset.createdBy.phone) {
                      <div class="creator-detail">{{ asset.createdBy.phone }}</div>
                    }
                  </div>
                </div>
              } @else {
                <div class="empty-state">Data not available</div>
              }
            </div>

            <!-- Transcript -->
            <div class="section">
              <div class="section-label">Transcript</div>
              @if (asset.txt) {
                <pre class="transcript-box">{{ asset.txt }}</pre>
              } @else {
                <div class="empty-state">Not available</div>
              }
            </div>

            <!-- Tasks -->
            <div class="section">
              <div class="section-label">Related Messages</div>
              @if (asset.tasks && asset.tasks.length > 0) {
                <div class="tasks-list">
                  @for (task of asset.tasks; track task.token) {
                    <div class="task-card">
                      <div class="task-header">
                        <span class="task-token">{{ task.token }}</span>
                        <div class="task-actions">
                          @if (task.status) {
                            <cm-ui-chip size="sm" [tone]="statusTone(task.status)" [label]="task.status" />
                          }
                          <a [href]="previewUrl(task.token!)" target="_blank" class="preview-link">Open preview →</a>
                        </div>
                      </div>
                      <div class="task-body">
                        <div class="task-grid">
                          @if (task.campaignTitle) {
                            <div>
                              <div class="task-field-label">Campaign</div>
                              <div class="task-field-value">{{ task.campaignTitle }}</div>
                            </div>
                          }
                          @if (task.campaignName) {
                            <div>
                              <div class="task-field-label">Campaign Name</div>
                              <div class="task-field-value">{{ task.campaignName }}</div>
                            </div>
                          }
                          <div>
                            <div class="task-field-label">Last Updated</div>
                            <div class="task-field-value">{{ toDate(task.lastUpdated) | date:'medium' }}</div>
                          </div>
                        </div>
                        @if (task.senderFirstname || task.senderEmail) {
                          <div class="recipient-section">
                            <div class="recipient-label">Sender</div>
                            <div class="task-grid">
                              <div>
                                <div class="task-field-label">Name</div>
                                <div class="task-field-value">{{ task.senderFirstname }} {{ task.senderLastname }}</div>
                              </div>
                              @if (task.senderEmail) {
                                <div>
                                  <div class="task-field-label">Email</div>
                                  <div class="task-field-value">{{ task.senderEmail }}</div>
                                </div>
                              }
                              @if (task.senderPhone) {
                                <div>
                                  <div class="task-field-label">Phone</div>
                                  <div class="task-field-value">{{ task.senderPhone }}</div>
                                </div>
                              }
                              @if (task.senderExternalId) {
                                <div>
                                  <div class="task-field-label">External ID</div>
                                  <div class="task-field-value">{{ task.senderExternalId }}</div>
                                </div>
                              }
                            </div>
                          </div>
                        }
                        @if (task.receiverFirstname || task.receiverEmail) {
                          <div class="recipient-section">
                            <div class="recipient-label">Recipient</div>
                            <div class="task-grid">
                              <div>
                                <div class="task-field-label">Name</div>
                                <div class="task-field-value">{{ task.receiverFirstname }} {{ task.receiverLastname }}</div>
                              </div>
                              @if (task.receiverEmail) {
                                <div>
                                  <div class="task-field-label">Email</div>
                                  <div class="task-field-value">{{ task.receiverEmail }}</div>
                                </div>
                              }
                              @if (task.receiverPhone) {
                                <div>
                                  <div class="task-field-label">Phone</div>
                                  <div class="task-field-value">{{ task.receiverPhone }}</div>
                                </div>
                              }
                              @if (task.receiverExternalId) {
                                <div>
                                  <div class="task-field-label">External ID</div>
                                  <div class="task-field-value">{{ task.receiverExternalId }}</div>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              } @else {
                <div class="empty-state">No messages found for this media asset</div>
              }
            </div>

          </div>
        </div>
      }

   
    </div>

    <div class="report-footer">Highp — Media Library Audit Report</div>

  </div>
} @else {
  <div class="no-data">No report data available.</div>
}
